import React, { useEffect, useMemo, useRef, useState } from "react";
import Draggable from "react-draggable";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";

import DialogObjetivoV2PatamarEditar from "./DialogObjetivoV2PatamarEditar";
import ObjetivoV2HistoricoClientes from "./ObjetivoV2HistoricoClientes";
import ObjetivoV2UniversoClientes from "./ObjetivoV2UniversoClientes";
import ObjetivoV2Patamares from "./ObjetivoV2Patamares";
import ObjetivoV2DadosGerais from "./ObjetivoV2DadosGerais";
import DialogObjetivoV2Catalogo from "./DialogObjetivoV2Catalogo";
import ObjetivoV2Equipas from "./ObjetivoV2Equipas";
import ObjetivoV2Vendedores from "./ObjetivoV2Vendedores";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#dialog-objetivo-v2-editar-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const EMPTY_FORM = {
  idobjetivonome: "",
  idobjetivogrupo: "",
  dataini: "",
  datafim: "",
  metrica: "CLIENTES",
  patamares_modo: "MEDIA",
  valor_objetivo: "",
  valor_objetivo_manual: false,

  clientes_historico_modo: "TODOS",
  clientes_historico_dataini: "",
  clientes_historico_datafim: "",

  inativo: 0,
};

export default function DialogObjetivoV2Editar({ open, onClose, onSaved, objetivo = null }) {
  const { showAlert } = useAlert();
  const { userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [loadingObjetivo, setLoadingObjetivo] = useState(false);

  const dialogContentRef = useRef(null);
  const scrollTopAntesPatamarRef = useRef(0);

  const [nomes, setNomes] = useState([]);
  const [grupos, setGrupos] = useState([]);

  const [openNomeDialog, setOpenNomeDialog] = useState(false);
  const [nomeDialogModo, setNomeDialogModo] = useState("NOVO");
  const [nomeDialogValor, setNomeDialogValor] = useState("");

  const [openGrupoDialog, setOpenGrupoDialog] = useState(false);
  const [grupoDialogModo, setGrupoDialogModo] = useState("NOVO");
  const [grupoDialogValor, setGrupoDialogValor] = useState("");

  const [patamares, setPatamares] = useState([]);
  const [openPatamarDialog, setOpenPatamarDialog] = useState(false);
  const [patamarEmEdicao, setPatamarEmEdicao] = useState(null);

  const [filtros, setFiltros] = useState([]);
  const [bloqueios, setBloqueios] = useState([]);
  const [submarcasHistorico, setSubmarcasHistorico] = useState([]);
  const [equipas, setEquipas] = useState([]);
  const [vendedores, setVendedores] = useState([]);

  const [catalogoSegmentos, setCatalogoSegmentos] = useState([]);
  const [catalogoGruposClientes, setCatalogoGruposClientes] = useState([]);
  const [catalogoBloqueiosFornecimento, setCatalogoBloqueiosFornecimento] = useState([]);
  const [catalogoBloqueiosFaturacao, setCatalogoBloqueiosFaturacao] = useState([]);
  const [catalogoBloqueiosOrdem, setCatalogoBloqueiosOrdem] = useState([]);

  const [catalogoVendedores, setCatalogoVendedores] = useState([]);

  const [clientesOpcoes, setClientesOpcoes] = useState([]);
  const [clienteTermo, setClienteTermo] = useState("");
  const [loadingClientes, setLoadingClientes] = useState(false);

  const [submarcasHistoricoOpcoes, setSubmarcasHistoricoOpcoes] = useState([]);
  const [submarcaHistoricoTermo, setSubmarcaHistoricoTermo] = useState("");
  const [loadingSubmarcasHistorico, setLoadingSubmarcasHistorico] = useState(false);

  const [idObjetivo, setIdObjetivo] = useState(0);

  const [form, setForm] = useState({
    ...EMPTY_FORM,
  });

  const isEdicao = Number(idObjetivo || 0) > 0;

  useEffect(() => {
    if (!open) {
      return;
    }

    const idInicial = Number(objetivo?.id || 0);

    setIdObjetivo(idInicial);

    if (idInicial > 0) {
      setForm({
        ...EMPTY_FORM,
        idobjetivonome: objetivo?.idobjetivonome ?? "",
        idobjetivogrupo: objetivo?.idobjetivogrupo ?? "",
        dataini: String(objetivo?.dataini || "").slice(0, 10),
        datafim: String(objetivo?.datafim || "").slice(0, 10),
        metrica: objetivo?.metrica || "CLIENTES",
        patamares_modo: objetivo?.patamares_modo || "MEDIA",
        valor_objetivo: objetivo?.valor_objetivo ?? "",
        valor_objetivo_manual: objetivo?.valor_objetivo_manual ?? true,

        clientes_historico_modo: objetivo?.clientes_historico_modo || "TODOS",

        clientes_historico_dataini: String(objetivo?.clientes_historico_dataini || "").slice(0, 10),

        clientes_historico_datafim: String(objetivo?.clientes_historico_datafim || "").slice(0, 10),

        inativo: Number(objetivo?.inativo || 0) === 1 ? 1 : 0,
      });
    } else {
      setForm({
        ...EMPTY_FORM,
      });

      setFiltros([]);
      setBloqueios([]);
      setSubmarcasHistorico([]);
      setEquipas([]);
      setVendedores([]);
      setPatamares([]);
    }
  }, [open, objetivo?.id]);

  useEffect(() => {
    let ativo = true;

    const carregarCatalogos = async () => {
      if (!open) {
        return;
      }

      setLoading(true);

      try {
        const [
          [payloadCabecalho, errCabecalho],
          [payloadFiltros, errFiltros],
          [payloadVendedores, errVendedores],
        ] = await Promise.all([
          handleApi(api.post("Comercial/SelObjetivoV2CatalogosCabecalho")),
          handleApi(api.post("Comercial/SelObjetivoV2CatalogosFiltros")),
          handleApi(api.post("Comercial/SelObjetivoV2VendedoresCatalogo")),
        ]);

        if (!ativo) {
          return;
        }

        if (errCabecalho) {
          showAlert(errCabecalho, "error");
          return;
        }

        if (errFiltros) {
          showAlert(errFiltros, "error");
          return;
        }

        if (errVendedores) {
          showAlert(errVendedores, "error");
          return;
        }

        const dataCabecalho = payloadCabecalho?.data ?? payloadCabecalho ?? {};

        const dataFiltros = payloadFiltros?.data ?? payloadFiltros ?? {};

        setNomes(Array.isArray(dataCabecalho?.nomes) ? dataCabecalho.nomes : []);

        setGrupos(Array.isArray(dataCabecalho?.grupos) ? dataCabecalho.grupos : []);

        setCatalogoSegmentos(Array.isArray(dataFiltros?.segmentos) ? dataFiltros.segmentos : []);

        setCatalogoGruposClientes(Array.isArray(dataFiltros?.grupos) ? dataFiltros.grupos : []);

        setCatalogoBloqueiosFornecimento(
          Array.isArray(dataFiltros?.bloqueiosFornecimento) ? dataFiltros.bloqueiosFornecimento : []
        );

        setCatalogoBloqueiosFaturacao(
          Array.isArray(dataFiltros?.bloqueiosFaturacao) ? dataFiltros.bloqueiosFaturacao : []
        );

        setCatalogoBloqueiosOrdem(
          Array.isArray(dataFiltros?.bloqueiosOrdem) ? dataFiltros.bloqueiosOrdem : []
        );

        const dataVendedores = payloadVendedores?.data ?? payloadVendedores ?? [];

        setCatalogoVendedores(Array.isArray(dataVendedores) ? dataVendedores : []);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregarCatalogos();

    return () => {
      ativo = false;
    };
  }, [open, showAlert]);

  useEffect(() => {
    let ativo = true;

    const carregarObjetivoEdicao = async () => {
      const id = Number(objetivo?.id || 0);

      if (!open || id <= 0) {
        return;
      }

      setLoadingObjetivo(true);

      try {
        const [payload, err] = await handleApi(
          api.post("Comercial/SelObjetivoV2Editar", {
            id,
          })
        );

        if (!ativo) {
          return;
        }

        if (err) {
          showAlert(err, "error");
          return;
        }

        const data = payload?.data ?? payload ?? {};
        const objetivoBd = data?.objetivo ?? null;

        if (!objetivoBd?.id) {
          showAlert("Não foi possível carregar o objetivo.", "error");
          return;
        }

        setIdObjetivo(Number(objetivoBd.id));

        setForm({
          ...EMPTY_FORM,
          idobjetivonome: objetivoBd.idobjetivonome ?? "",
          idobjetivogrupo: objetivoBd.idobjetivogrupo ?? "",
          dataini: String(objetivoBd.dataini || "").slice(0, 10),
          datafim: String(objetivoBd.datafim || "").slice(0, 10),
          metrica: objetivoBd.metrica || "CLIENTES",
          patamares_modo: objetivoBd.patamares_modo || "MEDIA",
          valor_objetivo: objetivoBd.valor_objetivo ?? "",
          valor_objetivo_manual: objetivoBd.valor_objetivo_manual ?? true,

          clientes_historico_modo: objetivoBd.clientes_historico_modo || "TODOS",

          clientes_historico_dataini: String(objetivoBd.clientes_historico_dataini || "").slice(
            0,
            10
          ),

          clientes_historico_datafim: String(objetivoBd.clientes_historico_datafim || "").slice(
            0,
            10
          ),

          inativo: Number(objetivoBd.inativo || 0) === 1 ? 1 : 0,
        });

        setFiltros(Array.isArray(data?.filtros) ? data.filtros : []);

        setBloqueios(Array.isArray(data?.bloqueios) ? data.bloqueios : []);

        setSubmarcasHistorico(
          Array.isArray(data?.submarcas_historico) ? data.submarcas_historico : []
        );

        setEquipas(Array.isArray(data?.equipas) ? data.equipas : []);
        setVendedores(Array.isArray(data?.vendedores) ? data.vendedores : []);

        const novosPatamares = Array.isArray(data?.patamares)
          ? data.patamares.map((patamar) => ({
              ...patamar,
              marcas: Array.isArray(patamar?.marcas) ? patamar.marcas : [],
            }))
          : [];

        setPatamares(novosPatamares);
      } finally {
        if (ativo) {
          setLoadingObjetivo(false);
        }
      }
    };

    carregarObjetivoEdicao();

    return () => {
      ativo = false;
    };
  }, [open, objetivo?.id, showAlert]);

  const nomeSelecionado = useMemo(
    () => nomes.find((x) => String(x.id) === String(form.idobjetivonome)) || null,
    [nomes, form.idobjetivonome]
  );

  const grupoSelecionado = useMemo(
    () => grupos.find((x) => String(x.id) === String(form.idobjetivogrupo)) || null,
    [grupos, form.idobjetivogrupo]
  );

  const totalDistribuido = useMemo(() => {
    const refsEquipa = new Set(
      (Array.isArray(equipas) ? equipas : []).flatMap((equipa) =>
        (Array.isArray(equipa?.vendedores) ? equipa.vendedores : [])
          .map((vendedor) => String(vendedor?.refvendedor || vendedor?.ref || "").trim())
          .filter(Boolean)
      )
    );

    const totalVendedores = (Array.isArray(vendedores) ? vendedores : []).reduce(
      (total, vendedor) => {
        const refVendedor = String(vendedor?.refvendedor || vendedor?.ref || "").trim();

        if (!refVendedor || refsEquipa.has(refVendedor)) {
          return total;
        }

        const valor = Number(vendedor?.valor || 0);

        return total + (Number.isFinite(valor) && valor > 0 ? valor : 0);
      },
      0
    );

    const totalEquipas = (Array.isArray(equipas) ? equipas : []).reduce((total, equipa) => {
      const valor = Number(equipa?.valor || 0);

      return total + (Number.isFinite(valor) && valor > 0 ? valor : 0);
    }, 0);

    return totalVendedores + totalEquipas;
  }, [vendedores, equipas]);

  useEffect(() => {
    if (form.valor_objetivo_manual) {
      return;
    }

    setForm((prev) => ({
      ...prev,
      valor_objetivo: totalDistribuido > 0 ? totalDistribuido : "",
    }));
  }, [totalDistribuido, form.valor_objetivo_manual]);

  const guardarFiltroObjetivo = async (tipo, sentido, valores) => {
    if (!isEdicao || Number(idObjetivo || 0) <= 0) {
      showAlert("Guarda primeiro os dados gerais do objetivo.", "warning");
      return false;
    }

    const refs = (Array.isArray(valores) ? valores : [])
      .map((x) => String(x || "").trim())
      .filter(Boolean);

    const sentidoFinal = String(sentido || "")
      .trim()
      .toUpperCase();

    const [payload, err, meta] = await handleApi(
      api.post("Comercial/UpdObjetivoV2Filtros", {
        idobjetivo: Number(idObjetivo),
        tipo,
        sentido: sentidoFinal,
        valores: refs,
      })
    );

    if (err) {
      showAlert(err, "error");
      return false;
    }

    const data = payload?.data ?? payload ?? {};

    const linhas = Array.isArray(data?.valores) ? data.valores : [];

    const linhasEstado =
      linhas.length > 0 || sentidoFinal === ""
        ? linhas
        : [
            {
              tipo,
              sentido: sentidoFinal,
              valor: "",
            },
          ];

    setFiltros((prev) => [
      ...prev.filter(
        (x) =>
          String(x?.tipo || "")
            .trim()
            .toUpperCase() !== tipo
      ),
      ...linhasEstado,
    ]);

    showAlert(meta?.message ?? "Filtro atualizado.", meta?.severity ?? "success");

    return true;
  };

  const guardarBloqueiosObjetivo = async (tipo, valores) => {
    if (!isEdicao || Number(idObjetivo || 0) <= 0) {
      showAlert("Guarda primeiro os dados gerais do objetivo.", "warning");
      return false;
    }

    const refs = (Array.isArray(valores) ? valores : [])
      .map((x) => String(x || "").trim())
      .filter(Boolean);

    const [, err, meta] = await handleApi(
      api.post("Comercial/UpdObjetivoV2Bloqueios", {
        idobjetivo: Number(idObjetivo),
        tipo,
        valores: refs,
      })
    );

    if (err) {
      showAlert(err, "error");
      return false;
    }

    setBloqueios((prev) => [
      ...prev.filter(
        (x) =>
          String(x?.tipo || "")
            .trim()
            .toUpperCase() !== tipo
      ),
      ...refs.map((valor) => ({
        tipo,
        valor,
      })),
    ]);

    showAlert(meta?.message ?? "Bloqueios atualizados.", meta?.severity ?? "success");

    return true;
  };

  const pesquisarClientes = async (term) => {
    const texto = String(term || "").trim();

    setClienteTermo(texto);

    if (texto.length < 2) {
      setClientesOpcoes([]);
      return;
    }

    setLoadingClientes(true);

    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelObjetivoV2ClientesCombo", {
          term: texto,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      const data = payload?.data ?? payload ?? [];

      setClientesOpcoes(Array.isArray(data) ? data : []);
    } finally {
      setLoadingClientes(false);
    }
  };

  const pesquisarSubmarcasHistorico = async (term) => {
    const texto = String(term || "").trim();

    setSubmarcaHistoricoTermo(texto);

    if (texto.length < 2) {
      setSubmarcasHistoricoOpcoes([]);
      return;
    }

    setLoadingSubmarcasHistorico(true);

    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelObjetivoV2SubmarcasHistorico", {
          term: texto,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      const data = payload?.data ?? payload ?? [];

      setSubmarcasHistoricoOpcoes(Array.isArray(data) ? data : []);
    } finally {
      setLoadingSubmarcasHistorico(false);
    }
  };

  const abrirNovoNome = () => {
    setNomeDialogModo("NOVO");
    setNomeDialogValor("");
    setOpenNomeDialog(true);
  };

  const abrirEditarNome = () => {
    if (!nomeSelecionado) {
      return;
    }

    setNomeDialogModo("EDITAR");
    setNomeDialogValor(nomeSelecionado?.nome || "");
    setOpenNomeDialog(true);
  };

  const abrirNovoGrupo = () => {
    setGrupoDialogModo("NOVO");
    setGrupoDialogValor("");
    setOpenGrupoDialog(true);
  };

  const abrirEditarGrupo = () => {
    if (!grupoSelecionado) {
      return;
    }

    setGrupoDialogModo("EDITAR");
    setGrupoDialogValor(grupoSelecionado?.nome || "");
    setOpenGrupoDialog(true);
  };

  const guardarNome = async () => {
    const nome = String(nomeDialogValor || "")
      .trim()
      .toUpperCase();

    if (!nome) {
      showAlert("Indica o nome do objetivo.", "warning");
      return;
    }

    setLoading(true);

    try {
      const endpoint =
        nomeDialogModo === "EDITAR" ? "Comercial/UpdObjetivoNomeV2" : "Comercial/InsObjetivoNomeV2";

      const body =
        nomeDialogModo === "EDITAR"
          ? {
              id: Number(nomeSelecionado?.id || 0),
              nome,
            }
          : {
              nome,
            };

      const [payload, err, meta] = await handleApi(api.post(endpoint, body));

      if (err) {
        showAlert(err, "error");
        return;
      }

      const registo = payload?.data ?? payload ?? null;

      showAlert(meta?.message ?? "Nome do objetivo guardado.", meta?.severity ?? "success");

      const [payloadCatalogos, errCatalogos] = await handleApi(
        api.post("Comercial/SelObjetivoV2CatalogosCabecalho")
      );

      if (errCatalogos) {
        showAlert(errCatalogos, "error");
        return;
      }

      const dataCatalogos = payloadCatalogos?.data ?? payloadCatalogos ?? {};

      const novosNomes = Array.isArray(dataCatalogos?.nomes) ? dataCatalogos.nomes : [];

      setNomes(novosNomes);

      if (registo?.id) {
        setForm((prev) => ({
          ...prev,
          idobjetivonome: registo.id,
        }));
      }

      setOpenNomeDialog(false);
      setNomeDialogValor("");
    } finally {
      setLoading(false);
    }
  };

  const guardarGrupo = async () => {
    const nome = String(grupoDialogValor || "")
      .trim()
      .toUpperCase();

    if (!nome) {
      showAlert("Indica o grupo do objetivo.", "warning");
      return;
    }

    setLoading(true);

    try {
      const endpoint =
        grupoDialogModo === "EDITAR"
          ? "Comercial/UpdObjetivoGrupoV2"
          : "Comercial/InsObjetivoGrupoV2";

      const body =
        grupoDialogModo === "EDITAR"
          ? {
              id: Number(grupoSelecionado?.id || 0),
              nome,
            }
          : {
              nome,
            };

      const [payload, err, meta] = await handleApi(api.post(endpoint, body));

      if (err) {
        showAlert(err, "error");
        return;
      }

      const registo = payload?.data ?? payload ?? null;

      showAlert(meta?.message ?? "Grupo do objetivo guardado.", meta?.severity ?? "success");

      const [payloadCatalogos, errCatalogos] = await handleApi(
        api.post("Comercial/SelObjetivoV2CatalogosCabecalho")
      );

      if (errCatalogos) {
        showAlert(errCatalogos, "error");
        return;
      }

      const dataCatalogos = payloadCatalogos?.data ?? payloadCatalogos ?? {};

      const novosGrupos = Array.isArray(dataCatalogos?.grupos) ? dataCatalogos.grupos : [];

      setGrupos(novosGrupos);

      if (registo?.id) {
        setForm((prev) => ({
          ...prev,
          idobjetivogrupo: registo.id,
        }));
      }

      setOpenGrupoDialog(false);
      setGrupoDialogValor("");
    } finally {
      setLoading(false);
    }
  };

  const guardarObjetivo = async () => {
    if (!form.idobjetivonome) {
      showAlert("Seleciona o nome do objetivo.", "warning");
      return;
    }

    if (!form.idobjetivogrupo) {
      showAlert("Seleciona o grupo do objetivo.", "warning");
      return;
    }

    if (!form.dataini || !form.datafim) {
      showAlert("Indica as datas de início e fim.", "warning");
      return;
    }

    if (form.datafim < form.dataini) {
      showAlert("A data final não pode ser anterior à data inicial.", "warning");
      return;
    }

    if (form.valor_objetivo !== "" && Number(form.valor_objetivo) < 0) {
      showAlert("O valor do objetivo não pode ser negativo.", "warning");
      return;
    }

    if (form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS") {
      if (!form.clientes_historico_dataini || !form.clientes_historico_datafim) {
        showAlert("Indica o período do histórico de clientes.", "warning");
        return;
      }

      if (form.clientes_historico_datafim < form.clientes_historico_dataini) {
        showAlert("A data final do histórico não pode ser anterior à data inicial.", "warning");
        return;
      }

      if (submarcasHistorico.length === 0) {
        showAlert("Seleciona pelo menos uma submarca para o histórico.", "warning");
        return;
      }
    }

    for (const equipa of equipas) {
      const nomeEquipa = String(equipa?.nome || "").trim();

      if (!nomeEquipa) {
        showAlert("Indica o nome de todas as equipas.", "warning");
        return;
      }

      if (
        equipa?.valor !== "" &&
        equipa?.valor !== null &&
        equipa?.valor !== undefined &&
        Number(equipa.valor) < 0
      ) {
        showAlert("O valor da equipa não pode ser negativo.", "warning");
        return;
      }
    }

    setLoading(true);

    try {
      const endpoint = isEdicao
        ? "Comercial/UpdObjetivoV2Cabecalho"
        : "Comercial/InsObjetivoV2Cabecalho";

      const body = {
        ...(isEdicao
          ? {
              id: Number(idObjetivo),
              inativo: Number(form.inativo || 0),
            }
          : {
              criadopor:
                userData?.nome ||
                userData?.username ||
                userData?.email ||
                String(userData?.id || ""),
            }),

        idobjetivonome: Number(form.idobjetivonome),
        idobjetivogrupo: Number(form.idobjetivogrupo),
        dataini: form.dataini,
        datafim: form.datafim,
        metrica: form.metrica,
        patamares_modo: form.metrica === "CLIENTES" ? form.patamares_modo : "QUALQUER",
        valor_objetivo: form.valor_objetivo === "" ? null : Number(form.valor_objetivo),
        valor_objetivo_manual: Boolean(form.valor_objetivo_manual),

        clientes_historico_modo: form.clientes_historico_modo || "TODOS",

        clientes_historico_dataini:
          form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS"
            ? form.clientes_historico_dataini || null
            : null,

        clientes_historico_datafim:
          form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS"
            ? form.clientes_historico_datafim || null
            : null,
      };

      const [payload, err, meta] = await handleApi(api.post(endpoint, body));

      if (err) {
        showAlert(err, "error");
        return;
      }

      const registo = payload?.data ?? payload ?? null;
      const idRecebido = Number(registo?.id || 0);

      if (idRecebido <= 0) {
        showAlert(
          isEdicao
            ? "O objetivo foi alterado, mas não foi devolvido um ID válido."
            : "O objetivo foi criado, mas não foi devolvido um ID válido.",
          "error"
        );
        return;
      }

      setIdObjetivo(idRecebido);

      if (form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS") {
        const refsSubmarcasHistorico = submarcasHistorico
          .map((item) => String(item?.refsubmarca || item?.ref || "").trim())
          .filter(Boolean);

        const [, errHistorico] = await handleApi(
          api.post("Comercial/UpdObjetivoV2HistoricoSubmarcas", {
            idobjetivo: idRecebido,
            submarcas: refsSubmarcasHistorico,
          })
        );

        if (errHistorico) {
          showAlert(errHistorico, "error");
          return;
        }
      } else {
        const [, errHistorico] = await handleApi(
          api.post("Comercial/UpdObjetivoV2HistoricoSubmarcas", {
            idobjetivo: idRecebido,
            submarcas: [],
          })
        );

        if (errHistorico) {
          showAlert(errHistorico, "error");
          return;
        }
      }

      const equipasGuardar = equipas.map((equipa) => ({
        nome: String(equipa?.nome || "")
          .trim()
          .toUpperCase(),

        valor:
          equipa?.valor === "" || equipa?.valor === null || equipa?.valor === undefined
            ? null
            : parseInt(equipa.valor, 10),

        vendedores: (Array.isArray(equipa?.vendedores) ? equipa.vendedores : [])
          .map((vendedor) => String(vendedor?.refvendedor || vendedor?.ref || "").trim())
          .filter(Boolean),
      }));

      const [, errEquipas] = await handleApi(
        api.post("Comercial/UpdObjetivoV2Equipas", {
          idobjetivo: idRecebido,
          equipas: equipasGuardar,
        })
      );

      if (errEquipas) {
        showAlert(errEquipas, "error");
        return;
      }

      const vendedoresGuardar = vendedores
        .map((vendedor) => ({
          refvendedor: String(vendedor?.refvendedor || vendedor?.ref || "").trim(),

          valor:
            vendedor?.valor === "" || vendedor?.valor === null || vendedor?.valor === undefined
              ? 0
              : parseInt(vendedor.valor, 10) || 0,
        }))
        .filter((vendedor) => vendedor.refvendedor && vendedor.valor > 0);

      const [, errVendedores] = await handleApi(
        api.post("Comercial/UpdObjetivoV2Vendedores", {
          idobjetivo: idRecebido,
          vendedores: vendedoresGuardar,
        })
      );

      if (errVendedores) {
        showAlert(errVendedores, "error");
        return;
      }

      showAlert(
        meta?.message ?? (isEdicao ? "Objetivo V2 alterado." : "Objetivo V2 criado."),
        meta?.severity ?? "success"
      );

      if (isEdicao) {
        onSaved?.();
        onClose?.();
      }
    } finally {
      setLoading(false);
    }
  };

  const abrirNovoPatamar = () => {
    setPatamarEmEdicao(null);
    setOpenPatamarDialog(true);
  };

  const abrirEditarPatamar = (patamar) => {
    if (!patamar) {
      return;
    }

    setPatamarEmEdicao(patamar);
    setOpenPatamarDialog(true);
  };

  const guardarPatamar = async (patamar) => {
    if (!patamar) {
      return;
    }

    if (!isEdicao || Number(idObjetivo || 0) <= 0) {
      showAlert("Guarda primeiro os dados gerais do objetivo.", "warning");
      return;
    }

    scrollTopAntesPatamarRef.current = dialogContentRef.current?.scrollTop || 0;

    setLoading(true);

    try {
      const isEditarPatamar = Number(patamarEmEdicao?.id || 0) > 0;

      const endpoint = isEditarPatamar
        ? "Comercial/UpdObjetivoV2PatamarCabecalho"
        : "Comercial/InsObjetivoV2PatamarCabecalho";

      const body = {
        ...(isEditarPatamar
          ? {
              id: Number(patamarEmEdicao.id),
            }
          : {}),

        idobjetivo: Number(idObjetivo),
        ordem: Number(patamar.ordem || 0),

        nome: String(patamar.nome || "")
          .trim()
          .toUpperCase(),

        reffabricante: String(patamar.reffabricante || "").trim(),

        marcas_modo: String(patamar.marcas_modo || "QUALQUER")
          .trim()
          .toUpperCase(),

        valor_empresa:
          patamar.valor_empresa === "" ||
          patamar.valor_empresa === null ||
          patamar.valor_empresa === undefined
            ? null
            : Number(patamar.valor_empresa),
      };

      const [payload, err, meta] = await handleApi(api.post(endpoint, body));

      if (err) {
        showAlert(err, "error");
        return;
      }

      const registo = payload?.data ?? payload ?? null;

      const idPatamar = Number(registo?.id || patamarEmEdicao?.id || 0);

      if (idPatamar <= 0) {
        showAlert("Não foi devolvido um ID válido para o patamar.", "error");
        return;
      }

      const refsMarcas = (Array.isArray(patamar.marcas) ? patamar.marcas : [])
        .map((marca) => String(marca?.refmarca || marca?.ref || "").trim())
        .filter(Boolean);

      if (refsMarcas.length === 0) {
        showAlert("Seleciona pelo menos uma marca.", "warning");
        return;
      }

      const [payloadMarcas, errMarcas, metaMarcas] = await handleApi(
        api.post("Comercial/UpdObjetivoV2PatamarMarcas", {
          idpatamar: idPatamar,
          marcas: refsMarcas,
        })
      );

      if (errMarcas) {
        showAlert(errMarcas, "error");
        return;
      }

      const marcasGuardadas = Array.isArray(payloadMarcas)
        ? payloadMarcas
        : Array.isArray(payloadMarcas?.data)
        ? payloadMarcas.data
        : [];

      // -------------------------------------------------------------
      // Submarcas de cada marca
      // -------------------------------------------------------------
      const marcasComSubmarcas = [];

      for (const marcaGuardada of marcasGuardadas) {
        const refmarca = String(marcaGuardada?.refmarca || "").trim();
        const idPatamarMarca = Number(marcaGuardada?.id || 0);

        if (!refmarca || idPatamarMarca <= 0) {
          showAlert("Não foi possível identificar uma das marcas do patamar.", "error");
          return;
        }

        const marcaForm = (Array.isArray(patamar.marcas) ? patamar.marcas : []).find(
          (marca) => String(marca?.refmarca || marca?.ref || "").trim() === refmarca
        );

        const submarcasSentido = String(marcaForm?.submarcas_sentido || "")
          .trim()
          .toUpperCase();

        const refsSubmarcas = (Array.isArray(marcaForm?.submarcas) ? marcaForm.submarcas : [])
          .map((submarca) => String(submarca?.refsubmarca || submarca?.ref || "").trim())
          .filter(Boolean);

        const [payloadSubmarcas, errSubmarcas] = await handleApi(
          api.post("Comercial/UpdObjetivoV2PatamarSubmarcas", {
            idpatamarmarca: idPatamarMarca,
            sentido: submarcasSentido,
            submarcas: refsSubmarcas,
          })
        );

        if (errSubmarcas) {
          showAlert(errSubmarcas, "error");
          return;
        }

        const dataSubmarcas = payloadSubmarcas?.data ?? payloadSubmarcas ?? {};

        const submarcasGuardadas = Array.isArray(dataSubmarcas?.submarcas)
          ? dataSubmarcas.submarcas
          : [];

        // -------------------------------------------------------------
        // Embalagens da marca
        // -------------------------------------------------------------
        const embalagensSentido = String(marcaForm?.embalagens_sentido || "")
          .trim()
          .toUpperCase();

        const refsEmbalagens = (Array.isArray(marcaForm?.embalagens) ? marcaForm.embalagens : [])
          .map((embalagem) => String(embalagem?.refembalagem || embalagem?.ref || "").trim())
          .filter(Boolean);

        const [payloadEmbalagens, errEmbalagens] = await handleApi(
          api.post("Comercial/UpdObjetivoV2PatamarEmbalagens", {
            idpatamarmarca: idPatamarMarca,
            sentido: embalagensSentido,
            embalagens: refsEmbalagens,
          })
        );

        if (errEmbalagens) {
          showAlert(errEmbalagens, "error");
          return;
        }

        const embalagensGuardadas = Array.isArray(payloadEmbalagens)
          ? payloadEmbalagens
          : Array.isArray(payloadEmbalagens?.data)
          ? payloadEmbalagens.data
          : [];

        // -------------------------------------------------------------
        // Materiais da marca
        // -------------------------------------------------------------
        const materiaisSentido = String(marcaForm?.materiais_sentido || "")
          .trim()
          .toUpperCase();

        const refsMateriais = (Array.isArray(marcaForm?.materiais) ? marcaForm.materiais : [])
          .map((material) => String(material?.refmaterial || material?.ref || "").trim())
          .filter(Boolean);

        const [payloadMateriais, errMateriais] = await handleApi(
          api.post("Comercial/UpdObjetivoV2PatamarMateriais", {
            idpatamarmarca: idPatamarMarca,
            sentido: materiaisSentido,
            materiais: refsMateriais,
          })
        );

        if (errMateriais) {
          showAlert(errMateriais, "error");
          return;
        }

        const materiaisGuardados = Array.isArray(payloadMateriais)
          ? payloadMateriais
          : Array.isArray(payloadMateriais?.data)
          ? payloadMateriais.data
          : [];

        marcasComSubmarcas.push({
          ...marcaGuardada,

          submarcas_sentido: dataSubmarcas?.sentido || "",
          submarcas: submarcasGuardadas,

          embalagens_sentido: embalagensSentido,
          embalagens: embalagensGuardadas,

          materiais_sentido: materiaisSentido,
          materiais: materiaisGuardados,
        });
      }

      const patamarAtualizado = {
        ...patamar,
        ...registo,
        id: idPatamar,
        marcas: marcasComSubmarcas,
      };

      setPatamares((prev) => {
        if (!isEditarPatamar) {
          return [...prev, patamarAtualizado];
        }

        return prev.map((item) =>
          Number(item.id) === Number(registo.id) ? patamarAtualizado : item
        );
      });

      showAlert(
        metaMarcas?.message ??
          meta?.message ??
          (isEditarPatamar ? "Patamar alterado." : "Patamar criado."),
        metaMarcas?.severity ?? meta?.severity ?? "success"
      );

      setOpenPatamarDialog(false);
      setPatamarEmEdicao(null);
    } finally {
      setLoading(false);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (dialogContentRef.current) {
            dialogContentRef.current.scrollTop = scrollTopAntesPatamarRef.current;
          }
        });
      });
    }
  };

  return (
    <>
      <DialogObjetivoV2Catalogo
        open={openNomeDialog}
        onClose={() => {
          setOpenNomeDialog(false);
          setNomeDialogValor("");
        }}
        titulo={nomeDialogModo === "EDITAR" ? "Editar nome do objetivo" : "Novo nome do objetivo"}
        label="Nome"
        valor={nomeDialogValor}
        setValor={setNomeDialogValor}
        onGuardar={guardarNome}
        loading={loading}
      />

      <DialogObjetivoV2Catalogo
        open={openGrupoDialog}
        onClose={() => {
          setOpenGrupoDialog(false);
          setGrupoDialogValor("");
        }}
        titulo={
          grupoDialogModo === "EDITAR" ? "Editar grupo do objetivo" : "Novo grupo do objetivo"
        }
        label="Grupo"
        valor={grupoDialogValor}
        setValor={setGrupoDialogValor}
        onGuardar={guardarGrupo}
        loading={loading}
      />

      {/* Patamar */}
      <DialogObjetivoV2PatamarEditar
        open={openPatamarDialog}
        onClose={() => {
          setOpenPatamarDialog(false);
          setPatamarEmEdicao(null);
        }}
        onGuardar={guardarPatamar}
        patamar={patamarEmEdicao}
        ordemSugerida={patamares.length + 1}
        reffabricanteSugerido={
          patamares.length > 0 ? patamares[patamares.length - 1]?.reffabricante || "" : ""
        }
      />

      {/* Principal */}
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xl"
        fullWidth
        PaperComponent={PaperComponent}
        PaperProps={{
          sx: {
            width: {
              xs: "calc(100vw - 16px)",
              sm: "94vw",
              lg: 1280,
            },
            maxWidth: "calc(100vw - 16px)",
          },
        }}
      >
        <DialogTitle
          id="dialog-objetivo-v2-editar-title"
          sx={{
            cursor: "move",
          }}
        >
          {isEdicao ? "Editar objetivo" : "Novo objetivo"}
        </DialogTitle>

        <DialogContent ref={dialogContentRef} dividers>
          {loading || loadingObjetivo ? (
            <MDBox py={4} display="flex" alignItems="center" justifyContent="center">
              <CircularProgress size={28} />
            </MDBox>
          ) : (
            <MDBox
              sx={{
                maxWidth: "100%",
                overflowX: "hidden",
              }}
            >
              <ObjetivoV2DadosGerais
                isEdicao={isEdicao}
                form={form}
                setForm={setForm}
                nomes={nomes}
                grupos={grupos}
                nomeSelecionado={nomeSelecionado}
                grupoSelecionado={grupoSelecionado}
                abrirNovoNome={abrirNovoNome}
                abrirEditarNome={abrirEditarNome}
                abrirNovoGrupo={abrirNovoGrupo}
                abrirEditarGrupo={abrirEditarGrupo}
                totalDistribuido={totalDistribuido}
              />

              <ObjetivoV2HistoricoClientes
                form={form}
                setForm={setForm}
                submarcasHistorico={submarcasHistorico}
                setSubmarcasHistorico={setSubmarcasHistorico}
                submarcasHistoricoOpcoes={submarcasHistoricoOpcoes}
                submarcaHistoricoTermo={submarcaHistoricoTermo}
                setSubmarcaHistoricoTermo={setSubmarcaHistoricoTermo}
                loadingSubmarcasHistorico={loadingSubmarcasHistorico}
                pesquisarSubmarcasHistorico={pesquisarSubmarcasHistorico}
                setSubmarcasHistoricoOpcoes={setSubmarcasHistoricoOpcoes}
              />

              <ObjetivoV2UniversoClientes
                isEdicao={isEdicao}
                filtros={filtros}
                bloqueios={bloqueios}
                catalogoSegmentos={catalogoSegmentos}
                catalogoGruposClientes={catalogoGruposClientes}
                catalogoBloqueiosFornecimento={catalogoBloqueiosFornecimento}
                catalogoBloqueiosFaturacao={catalogoBloqueiosFaturacao}
                catalogoBloqueiosOrdem={catalogoBloqueiosOrdem}
                clientesOpcoes={clientesOpcoes}
                clienteTermo={clienteTermo}
                loadingClientes={loadingClientes}
                guardarFiltroObjetivo={guardarFiltroObjetivo}
                guardarBloqueiosObjetivo={guardarBloqueiosObjetivo}
                pesquisarClientes={pesquisarClientes}
              />

              <ObjetivoV2Vendedores
                isEdicao={isEdicao}
                vendedores={vendedores}
                setVendedores={setVendedores}
                catalogoVendedores={catalogoVendedores}
                equipas={equipas}
              />

              <ObjetivoV2Equipas
                isEdicao={isEdicao}
                equipas={equipas}
                setEquipas={setEquipas}
                catalogoVendedores={catalogoVendedores}
                vendedores={vendedores}
              />

              <ObjetivoV2Patamares
                isEdicao={isEdicao}
                patamares={patamares}
                abrirNovoPatamar={abrirNovoPatamar}
                abrirEditarPatamar={abrirEditarPatamar}
              />
            </MDBox>
          )}
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" onClick={onClose}>
            Cancelar
          </MDButton>

          <MDButton color="info" onClick={guardarObjetivo} disabled={loading || loadingObjetivo}>
            {isEdicao ? "Guardar" : "Guardar e continuar"}
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
